import {SmallTexts} from "../enums/small-texts";
import {borderDesc, borderNames, noticeDesc, noticeName, noticeOtherTexts, titles} from "./texts-common-sections";
import {Documents, DocumentsIds} from "./documents";

const urlImages = "/assets/images/modules/section_3/";

export const Section3 = {
  ExplanationTexts: {
    title_expl01: "Pansements",
    text_expl01: "Les différents <span class='fw-bold'>pansements primaires ne sont pas destinés à être associés" +
      " entre eux sur une même plaie</span> (en dehors des pansements au charbon actif, des hydrogels et des formes" +
      " mèche)<sup>1</sup><br/><br/>" +
      "<span class='d-block color-white bg-red p-3 rounded-5 fw-bold'>Le pansement ne remplace pas un geste de" +
      " détersion, parage et/ou fermeture<sup>2</sup></span>",
    image_expl01: urlImages + "03sec01e_img.jpg",
    title_expl02: "Pansements&nbsp;: indication",
    text_expl02: "Les indications des différents pansements sont fondées sur leurs <span class='fw-bold'>PROPRIÉTÉS" +
      " PHYSICO-CHIMIQUES</span>, notamment&nbsp;:" +
      "<ul class='my-3'>" +
      "<li>leur <span class='fw-bold'>capacité d’absorption</span>,</li>" +
      "<li>le <span class='fw-bold'>stade</span> et la <span class='fw-bold'>cause de la plaie</span>,</li>" +
      "<li>l’<span class='fw-bold'>état de la peau</span> périlésionnelle.<sup>1</sup></li>" +
      "</ul>",
    image_expl02: urlImages + "03sec02e_img.jpg",
    title_expl03: "Pansements&nbsp;: critères de choix",
    text_expl03: "<span class='fw-bold'>Les critères de choix des pansements varient suivant les CARACTÉRISTIQUES DE" +
      " LA" +
      " PLAIE<sup>1-3</sup>&nbsp;:</span>" +
      "<ul class='my-4'>" +
      "<li class='mb-2'><span class='fw-bold'>Aspect et couleur</span>&nbsp;: nécrose, fibrine, bourgeonnement et épidermisation</li>" +
      "<li class='mb-2'><span class='fw-bold'>Quantité d’exsudat</span></li>" +
      "<li class='mb-2'><span class='fw-bold'>Localisation</span></li>" +
      "<li class='mb-2'><span class='fw-bold'>État de la peau périlésionnelle</span>&nbsp;: érosions, phlyctènes<sup>*</sup></li>" +
      "<li class='mb-2'><span class='fw-bold'>Taille</span>&nbsp;: surface et profondeur</li>" +
      "<li class='mb-2'><span class='fw-bold'>Rythme prévisionnel de renouvellement de pansement</span></li>" +
      "<li><span class='fw-bold'>Autre&nbsp;: malodorante, infectée, hémorragique, douloureuse</span></li>" +
      "</ul>",
    asterisks_expl03: ["Soulèvement de l'épiderme<sup>4</sup> créant une cavité localisée qui se remplit de liquide" +
    " séreux et translucide (phlyctène séreuse) ou d’éléments sanguins, coagulés ou non (phlyctène hématique). Une" +
    " phlyctène est généralement douloureuse.<sup>5</sup>"],
    title_expl04: "Les différents types de pansement",
    text_expl04: "<span class='d-block text-start'>Il existe différents types de pansement avec des caractéristiques" +
      " et des indications différentes.<sup>1</sup><br/>En voici un aperçu&nbsp;:</span>",
    text_flex_columns_expl04: [
      {
        group: "",
        title: "Pansements hydrocellulaires",
        content: "<ul class='text-start mb-0'>" +
          "<li class='mb-3'>Composés de polymères absorbants (généralement de la mousse de polyuréthane)</li>" +
          "<li>Existent sous forme adhésive ou non, en forme anatomique</li>" +
          "</ul>"
      },
      {
        group: '',
        title: 'Pansements hydrocolloïdes',
        content: "<ul class='text-start mb-0'>" +
          "<li class='mb-3'>Composés de carboxyméthylcellulose (CMC)</li>" +
          "<li>Existent en général sous forme de plaques adhésives plus ou moins épaisses.</li>" +
          "</ul>"
      }
    ],
    annexes_expl04: [
      "<span class='text-start d-block'><a class='doc-download' href='" + Documents.Document2 + "' data-document-id='" + DocumentsIds.Document2 + "' target='_blank'>Téléchargez</a> la" +
      " fiche récapitulative des différents types de pansements</span>",
    ],
    title_expl05: titles.titleSolutionsLohmanRauscher,
    text_expl05: "<img src='"+ urlImages +"03sec05e_img.png' />",
    asterisks_expl05: [
      "<span class='fw-bold'>" + borderNames.border + "</span>&nbsp;: " + borderDesc.border + "&nbsp;; **&nbsp;" +
      "<span class='fw-bold'>" + borderNames.borderLite + "</span>&nbsp;: " + borderDesc.borderLite
    ],
    title_expl06: titles.titleSolutionsLohmanRauscher,
    text_expl06: "<span class='text-start d-block'>Les gammes Suprasorb<sup>®</sup> P sensitive et Vliwasorb<sup>®</sup>" +
      " accompagnent les professionnels de santé et les patients dans la gestion efficace de l’exsudat.</span>" +
      "<img class='d-block my-3' src='" + urlImages +"03sec06e_img.png' />" +
      "<span class='d-block mt-4'>Découvrez ces 2 gammes</span>",
    asterisks_expl06: [
      "<span class='fw-bold'>" + borderNames.borderLite + "</span>&nbsp;: " + borderDesc.borderLite + "&nbsp;; " +
      "**&nbsp;<span class='fw-bold'>" + borderNames.nonBorder + "</span>&nbsp;: " + borderDesc.nonBorder + "&nbsp;;<br/>" +
      " ***&nbsp;<span class='fw-bold'>" + borderNames.border + "</span>&nbsp;: " + borderDesc.border + "&nbsp;; " +
      "****&nbsp;<span class='fw-bold'>" + borderNames.heel + "</span>&nbsp;: " + borderDesc.heel
    ],
    title_expl07: titles.titleGammeSuprasorbPSensitive,
    text_expl07: "Les pansements <span class='fw-bold'>hydrocellulaires siliconés de la gamme Suprasorb<sup>®</sup> P" +
      " sensitive</span> sont conçus pour les <span class='fw-bold'>plaies faiblement à fortement exsudatives</span>" +
      " (selon forme <span class='fst-italic'>border</span>, <span class='fst-italic'>border lite</span>, <span class='fst-italic'>non border</span>*).",
    image_expl07: urlImages + "03sec07e_img.png",
    asterisks_expl07: [
      "<span class='fw-bold'>" + borderNames.border + "</span>&nbsp;: " + borderDesc.border + ", " +
      "<span class='fw-bold'>" + borderNames.borderLite + "</span>&nbsp;: " + borderDesc.borderLite + ", " +
      "<span class='fw-bold'>" + borderNames.nonBorder + "</span>&nbsp;: " + borderDesc.nonBorder,
    ],
    list_buttons_expl07: [
      {
        group: "",
        title: "Découvrez la technicité d’un pansement Suprasorb<sup>®</sup> P sensitive",
        content: [
          {
            image: urlImages + "03sec07e_modal_img.png",
            small_texts: {
              1: SmallTexts.DFC2022041,
              2: SmallTexts.DFC2022045,
              3: SmallTexts.DFC2022046,
              4: SmallTexts.NoticeUtilisation,
              5: SmallTexts.DFC2022043,
              6: SmallTexts.DFC2022048,
              7: SmallTexts.DFC2022049,
              8: SmallTexts.DFC2022050,
              9: SmallTexts.DFC2022051,
            },
            asterisks: [
              // "Polyuréthane",
              "<span class=''>" + borderNames.border + "</span>&nbsp;: " + borderDesc.border + " **&nbsp;" +
              "<span class=''>Polyuréthane</span> ***&nbsp;" +
              "<span class=''>" + borderNames.nonBorder + "</span>&nbsp;: " + borderDesc.nonBorder,
            ]
          }
        ],
      }
    ],
    title_expl08: titles.titleGammeSuprasorbPSensitive,
    text_expl08: "La <span class='fw-bold'>localisation de la plaie</span> est un autre paramètre à prendre en" +
      " considération pour un conseil adapté à chaque patient&nbsp;:" +
      "<ul class='my-3'>" +
      "<li>sacrum</li>" +
      "<li>talon</li>" +
      "<li>sites difficiles à panser (tels que le coude ou le genou)</li>" +
      "</ul>",
    image_expl08: urlImages + "03sec08e_img.png",
    annexes_expl08: [
      "<span class='small-text d-block text-start mt-4'>" +
      "<span class='fw-bold'>" + borderNames.border + "</span>&nbsp;: " + borderDesc.border + "&nbsp;; " +
      "<span class='fw-bold'>" + borderNames.borderLite + "</span>&nbsp;: " + borderDesc.borderLite + "&nbsp;; " +
      "<span class='fw-bold'>" + borderNames.heel + "</span>&nbsp;: " + borderDesc.heel,
      "</span>"
    ],
    title_expl09: titles.titleGammeSuprasorbPSensitive,
    text_expl09: "<span class='text-start d-block'>La <span class='fw-bold'>gamme Suprasorb<sup>®</sup> P" +
      " sensitive</span> est indiquée pour de nombreux types de plaies, <span class='fw-bold'>superficielles</span>" +
      " ou <span class='fw-bold'>profondes</span>.<sup>1</sup></span>",
    text_flex_columns_expl09: [
      {
        image: urlImages + "03sec09_CHRO_e_img.png",
      },
      {
        image: urlImages + "03sec09_TRA_e_img.png",
      },
      {
        image: urlImages + "03sec09_CHIR_e_img.png",
      }
    ],
    title_expl10: titles.titleGammeSuprasorbPSensitive,
    image_expl10: urlImages + "Suprasorb.png",
    text_expl10: "Pourquoi recommander la gamme Suprasorb<sup>®</sup> P sensitive&nbsp;?",
    annexes_expl10: [
      "<div class='text-start bg-lightest-grey p-4 rounded-5'><span class='d-block mb-3 fw-bold color-green'>DOUCEUR" +
      " ET CONFORT</span><ul class='mb-0 small'><li>Adhère en douceur<sup>1</sup></li><li>Limite le risque" +
      " d’adhérence à la plaie lors des changements de pansements<sup>2</sup></li><li>Confortable grâce à sa mousse" +
      " absorbante en polyuréthane<sup>3</sup></li></ul></div>",
      "<div class='text-start bg-lightest-grey p-4 rounded-5'><span class='d-block mb-3 fw-bold" +
      " color-green'>PROTECTION</span><ul class='mb-0 small'><li>Forme une barrière contre les bactéries et" +
      " l’eau<sup>5</sup></li><li>Perméable à la vapeur d’eau<sup>4</sup></li></ul></div>",
      "<div class='text-start bg-lightest-grey p-4 rounded-5'><span class='d-block mb-3 fw-bold color-green'>GESTION" +
      " EFFICACE DE L’EXSUDAT</span><ul class='mb-0 small'><li>Facilite une absorption rapide de l’exsudat dans le" +
      " pansement<sup>6</sup></li><li>Maintient un milieu humide de la plaie<sup>7</sup></li></ul></div>",
    ],
    asterisks_expl10: ["Polyuréthane"],
    title_expl11: titles.titleGammeVliwasorb,
    image_expl11: urlImages + "Vliwasorb.png",
    text_expl11: "<span class='color-red'>Les <span class='fw-bold'>pansements hydrocellulaires</span>" +
      " de la gamme <span class='fw-bold'>Vliwasorb<sup>®</sup> Pro</span> sont des pansements <span class='fw-bold'>super" +
      " absorbants non adhérents</span>.</span><h2 class='fw-bold'>Vliwasorb<sup>®</sup> Pro</h2>Plaies moyennement" +
      " à très fortement exsudatives.<sup>*</sup>",
    asterisks_expl11: ["Le médecin déterminera la fréquence de renouvellement en fonction de l’état et du" +
    " degré d’exsudation. L’intervalle entre deux changements ne doit pas excéder sept jours"],
    list_buttons_expl11: [
      {
        group: "",
        title: "Découvrez la technicité d’un pansement Vliwasorb<sup>®</sup> Pro",
        content: [
          {
            title: "<span class='big-text'>Vliwasorb<sup>®</sup> Pro</span><br/>Plaies moyennement à très fortement exsudatives",
            image: urlImages + "03sec11e_modal_img.png",
            small_texts: {
              1: SmallTexts.NoticeUtilisation + ' ' + SmallTexts.VliwasorbPro,
              2: SmallTexts.DFC2019071,
              3: SmallTexts.DFC2019112,
              4: SmallTexts.DFC2019066,
              5: SmallTexts.DFC2019070,
            },
            asterisks: [
              "Données <em>in vitro</em>"
            ]
          }
        ],
      }
    ],
    title_expl12: titles.titleGammeVliwasorb,
    image_expl12: urlImages + "Vliwasorb-sensitive.png",
    text_expl12: "<span class='color-red'>Les <span class='fw-bold'>pansements hydrocellulaires</span>" +
      " de la gamme <span class='fw-bold'>Vliwasorb<sup>®</sup> sensitive</span> sont des pansements " +
      "<span class='fw-bold'>super absorbants siliconés</span>.</span>" +
      "<h2 class='fw-bold'>Vliwasorb<sup>®</sup> sensitive</h2>" +
      "Plaies moyennement à fortement exsudatives.<sup>*</sup>",
    asterisks_expl12: ["Le médecin déterminera la fréquence de renouvellement en fonction de l’état et du" +
    " degré d’exsudation. L’intervalle entre deux changements ne doit pas excéder sept jours"],
    list_buttons_expl12: [
      {
        group: "",
        title: "Découvrez la technicité d’un pansement Vliwasorb<sup>®</sup> sensitive",
        content: [
          {
            title: "<span class='big-text'>Vliwasorb<sup>®</sup> sensitive</span><br/>Plaies moyennement à fortement" +
              " exsudatives",
            image: urlImages + "03sec12e_modal_img.png",
            small_texts: {
              1: SmallTexts.NoticeUtilisation + ' ' + SmallTexts.VliwasorbSensitive,
              2: SmallTexts.DFC2021111,
              3: SmallTexts.DFC2021112,
              //4: SmallTexts.DFC2021113,
              5: SmallTexts.DFC2021123,
              //6: SmallTexts.DFC2021114,
              7: SmallTexts.DFC2021108,
              8: SmallTexts.DFC2021116,
            },
          }
        ],
      }
    ],
    title_expl13: titles.titleGammeVliwasorb,
    text_expl13: "<span class='d-block text-start'>Pourquoi recommander la gamme Vliwasorb<sup>®</sup>&nbsp;?</span>",
    asterisks_expl13: [
      "Données <em>in vitro</em>"
    ],
    text_flex_columns_expl13: [
      {
        group: "",
        title: "Superabsorbants",
        content: "<ul class='p-0 text-start mb-0'>" +
          "<li class='mb-3'>Rétention élevée, même sous compression<sup>1,2</sup></li>" +
          "<li class='mb-3'>Maintien d'un milieu humide<sup>3,4</sup></li>" +
          "<li>Intervalles prolongés entre chaque réfection<sup>5,6</sup></li>" +
          "</ul>"
      },
      {
        group: '',
        title: 'Protecteurs',
        content: "<ul class='p-0 text-start mb-0'>" +
          "<li class='mb-3'>Réduction de la charge microbienne<sup>*7,8</sup></li>" +
          "<li>Diminution du risque de macération<sup>3,9</sup></li>" +
          "</ul>"
      },
      {
        group: "",
        title: "Confortables",
        content: "<ul class='p-0 text-start mb-0'>" +
          "<li class='mb-3'>Doux<sup>10,11</sup></li>" +
          "<li class='mb-3'>Répartition homogène des exsudats<sup>12,13</sup></li>" +
          "<li>Confortable grâce à sa forme stable, même sous compression<sup>9,14</sup></li>" +
          "</ul>"
      },
    ],
    annexes_qst04: [
      "<span class='small-text d-block text-start mt-4'>" +
      "<span class='fw-bold'>" + borderNames.border + "</span>&nbsp;: " + borderDesc.border + ", " +
      "<span class='fw-bold'>" + borderNames.borderLite + "</span>&nbsp;: " + borderDesc.borderLite + ", " +
      "<span class='fw-bold'>" + borderNames.nonBorder + "</span>&nbsp;: " + borderDesc.nonBorder,
      "</span>",
    ],
    annexes_qst05: [
      "<span class='d-block text-start'>Pour vous aider, <a class='doc-download' href='" + Documents.Document3 + "' data-document-id='" + DocumentsIds.Document3 + "' target='_blank'>téléchargez le poster mémo</a></span>",
      "<span class='small-text d-block text-start mt-4'>" +
      "<span class='fw-bold'>" + borderNames.border + "</span>&nbsp;: " + borderDesc.border + ", " +
      "<span class='fw-bold'>" + borderNames.borderLite + "</span>&nbsp;: " + borderDesc.borderLite + ", " +
      "<span class='fw-bold'>" + borderNames.nonBorder + "</span>&nbsp;: " + borderDesc.nonBorder,
      "</span>",
    ],
  },
  Responses: {
    title_correct_q01: "Vous avez raison&nbsp;!",
    title_not_correct_q01: "Oups&nbsp;! Ce n’est pas ça",
    text_q01: "<ul class='small'>" +
      "<li>Les <span class='fw-bold'>pansements primaires</span> sont placés <span class='fw-bold'>AU CONTACT DE LA" +
      " PLAIE</span>.<sup>1,2</sup></li>" +
      "<li>Les <span class='fw-bold'>pansements secondaires</span> incluent les <span" +
      " class='fw-bold'>COMPRESSES</span> et les <span class='fw-bold'>MATÉRIELS DE FIXATION ET DE MAINTIEN (ADHÉSIF" +
      " OU BANDAGE)</span>. Certains pansements les nécessitent, d’autres non.<sup>1,2</sup></li>" +
      "</ul><p>La prescription d’un pansement sur ordonnance doit être la plus précise possible.<sup>1</sup></p>",
    image_q01: urlImages + "Plaie-schema.png",
    title_correct_q02: "Super&nbsp;!",
    title_not_correct_q02: "Vous y êtes presque&nbsp;!",
    text_correct_q02: "Vous avez reconnu le piège. Toutes ces caractéristiques sont importantes pour la qualité d’un" +
      " pansement à l’exception de l’adhésion à la plaie. En effet, le pansement idéal doit uniquement adhérer à la" +
      " peau saine et ne pas arracher les bourgeons néoformés. Certains pansements sont prévus pour avoir une" +
      " adhérence douce, et ainsi respecter ces bourgeons.<sup>1</sup>",
    text_not_correct_q02: "Il y avait un piège. Toutes ces caractéristiques sont importantes pour la qualité d’un" +
      " pansement à l’exception de l’adhésion à la plaie. En effet, le pansement idéal doit uniquement adhérer à la" +
      " peau saine et ne pas arracher les bourgeons néoformés. Certains pansements sont prévus pour avoir une" +
      " adhérence douce, et ainsi respecter ces bourgeons.<sup>1</sup>",
    title_correct_q03: "Vous avez trouvé&nbsp;!",
    title_not_correct_q03: "Vous ne l’avez pas reconnu&nbsp;!",
    text_q03: "Il s’agit du <span class='fw-bold color-green'>pansement hydrocellulaire</span>.",
    title_correct_q04: "Bravo&nbsp;!",
    title_not_correct_q04: "Pas tout à fait&nbsp;!",
    text_correct_q04: "Vous connaissez bien la gamme Suprasorb<sup>®</sup> P sensitive&nbsp;!",
    text_not_correct_q04: "Voici les différentes indications des pansements Suprasorb<sup>®</sup> P sensitive&nbsp;!",
    image_q04: urlImages + "03sec04q_img.png",
    title_correct_q05: "Échec et mat&nbsp;!",
    title_not_correct_q05: "Votre stratégie est à revoir&nbsp;!",
    text_q05: "Vous êtes en présence d’une plaie fibrineuse (partie jaune), en phase de bourgeonnement (partie" +
      " rouge). La quantité d’exsudat est faible et la plaie semble se situer dans une localisation facile d’accès :" +
      " le pansement <span class='fw-bold'>Suprasorb<sup>®</sup> P sensitive border lite</span> est une option" +
      " appropriée.",
    image_q05: urlImages + "03sec05q_img.png",
    annexes_q05: [
      "<span class='d-block text-start'>Pour avoir toujours un coup d’avance sur la plaie, " +
      "<a class='doc-download' href='" + Documents.Document3 + "' data-document-id='" + DocumentsIds.Document3 + "' target='_blank'>téléchargez le poster mémo</a></span>",
      "<span class='small-text d-block text-start mt-4'>" +
      "<span class='fw-bold'>" + borderNames.borderLite + "</span>&nbsp;: " + borderDesc.borderLite +
      "</span>",
    ],
  },
  EndTexts: {
    title_end01: "Bravo, vous avez maintenant compris les clés d’une strategie gagnante contre les plaies&nbsp;!",
    text_end01_p01: "Vous êtes prêt à mettre en pratique vos connaissances à l’aide de mises en situation concrètes.",
    text_end01_p02: "Avant de continuer la partie, téléchargez <a class='doc-download' href='" + Documents.Document4 + "' data-document-id='" + DocumentsIds.Document4 + "' target='_blank'>une fiche récapitulative</a> de ce module.",
    annexes_end01: [
      "<span class='fw-bold'>" + noticeName.SupraPSensitiveBorderMultisiteBorderSacrumHeel + "</span>" +
      noticeDesc.SupraPSensitiveBorderMultisiteBorderSacrumHeel + " <span class='fw-bold'>" + noticeName.SuprasorbPSensitiveNonBorder + "</span> " +
      noticeDesc.SuprasorbPSensitiveNonBorder,
      "<span class='fw-bold'>" + noticeName.SuprasorbPSensitiveBorderLiteMultisiteBorderLite + "</span> " +
      noticeDesc.SuprasorbPSensitiveBorderLiteMultisiteBorderLite,
      "<span class='fw-bold'>" + noticeName.VliwasorbSensitiveClasseIIb + "</span> " +
      noticeDesc.VliwasorbSensitiveClasseIIb + "<br/>" + noticeOtherTexts.DispositifsMedicaux,
      "<span class='d-block mt-2'></span>" +
      "<span class='fw-bold'>" + noticeName.VliwasorbProClasseIIb + "</span>&nbsp: " +
      noticeDesc.VliwasorbProClasseIIb,
      "<span class='fw-bold'>" + noticeName.VliwasorbAhesif + "</span>&nbsp: " +
      noticeDesc.VliwasorbAhesif,
      "<span class='fw-bold'>" + noticeName.SuprasorbFProtect + "</span>&nbsp: " +
      noticeDesc.SuprasorbFProtect,
      "<span class='fw-bold'>" + noticeName.Vliwazell + "</span>&nbsp: " +
      noticeDesc.Vliwazell + "<br/>" + noticeOtherTexts.DispositifsMedicauxClasseIIb,
      "<span class='d-block mt-2'></span>" +
      "<span class='fw-bold'>" + noticeName.SuprasorbHStandardSacrumBorder + "</span>&nbsp: " +
      noticeDesc.SuprasorbHStandardSacrumBorder,
      "<span class='fw-bold'>" + noticeName.SuprasorbHFin + "</span>&nbsp: " +
      noticeDesc.SuprasorbHFin + "<br/>" + noticeOtherTexts.DispositofsMedicauxHFin,
      "<span class='d-block mt-2'></span>" +
      noticeOtherTexts.LireAttentivement,
    ]
  }
}
